import { render } from "./SponsorPage.vue?vue&type=template&id=e147bf6c&scoped=true"
import script from "./SponsorPage.vue?vue&type=script&lang=js"
export * from "./SponsorPage.vue?vue&type=script&lang=js"

import "./SponsorPage.vue?vue&type=style&index=0&id=e147bf6c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e147bf6c"]])

export default __exports__